import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = useSelector((state) => state.user.userToken);
  useEffect(() => {
    if (!token) {
      location?.pathname === "/recent"
        ? navigate("/guest", { state: { data: location?.state?.data } })
        : navigate("/signIn");
    }
  }, []);

  return <>{children}</>;
};

export default ProtectedRoute;
